import { themes } from '@/themes'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    theme: _.cloneDeep(themes.default)
  },
  mutations: {
    setTheme(state, payload) {
      state.theme = payload.theme
    }
  },
  actions: {
    setTheme({ commit }, themeName) {
      const defaultName = process.env.VUE_APP_THEME
      const name = themeName || defaultName

      if(themes[name]) {
        commit('setTheme', { theme: _.cloneDeep(themes[name]) })
      }
    }
  },
  getters: {
    theme: state => {
      return state.theme
    },
    location: state => {
      return state.theme.location
    }
  }
}
